import React from "react";
import { BrandsProps } from "../../../../../components/brands/types";
import GoogleImage from "../../../../../images/pages/ru-index/brands/google.svg";
import AfishaImage from "../../../../../images/pages/ru-index/brands/afisha.svg";
import CSKAImage from "../../../../../images/pages/ru-index/brands/cska.svg";
import SpartakImage from "../../../../../images/pages/ru-index/brands/spartak.svg";
import RSHBImage from "../../../../../images/pages/ru-index/brands/rshb.svg";
import MSIImage from "../../../../../images/pages/ru-index/brands/msi.svg";
import HabrImage from "../../../../../images/pages/ru-index/brands/habr.svg";
import HSEImage from "../../../../../images/pages/ru-index/brands/hse.svg";
import RaiffesenImage from "../../../../../images/pages/ru-index/brands/raiffesen.svg";
import WrikeImage from "../../../../../images/pages/ru-index/brands/wrike.svg";
import AorusImage from "../../../../../images/pages/ru-index/brands/aorus.svg";
import VmwareImage from "../../../../../images/pages/ru-index/brands/vmware.svg";
import AIJImage from "../../../../../images/pages/ru-index/brands/aij.svg";
import PyaterochkaImage from "../../../../../images/pages/ru-index/brands/5chka.svg";
import FirstBitImage from "../../../../../images/pages/ru-index/brands/1bit.svg";
import YoomoneyImage from "../../../../../images/pages/ru-index/brands/yoomoney.svg";
import ROGImage from "../../../../../images/pages/ru-index/brands/rog.svg";
import DataForkImage from "../../../../../images/pages/ru-index/brands/datafork.svg";
import OzonTechImage from "../../../../../images/pages/ru-index/brands/ozontech.svg";
import NilettoImage from "../../../../../images/pages/ru-index/brands/niletto.svg";
import RDSImage from "../../../../../images/pages/ru-index/brands/rds.svg";
import RosgonkiImage from "../../../../../images/pages/ru-index/brands/rosgonki.svg";
import SberDevicesImage from "../../../../../images/pages/ru-index/brands/sberdevices.svg";
import {Translate} from "../../../../../locales/locales-utils";

export const brandsProps = (): BrandsProps => {
  return {
    title: Translate("Index.Brands.Title"),
    items: [
      <img src={GoogleImage} alt="Google" key="0" />,
      <img src={AfishaImage} alt="Афиша" key="1" />,
      <img src={CSKAImage} alt="ЦСКА" key="2" />,
      <img src={SpartakImage} alt="Спартак" key="3" />,
      <img src={RSHBImage} alt="РСХБ ИНТЕХ" key="4" />,
      <img src={MSIImage} alt="MSI" key="5" />,
      <img src={HabrImage} alt="Хабр" key="6" />,
      <img src={HSEImage} alt="ВШЕ" key="7" />,
      <img src={RaiffesenImage} alt="Raiffesen" key="8" />,
      <img src={WrikeImage} alt="Wrike" key="9" />,
      <img src={AorusImage} alt="Aorus" key="10" />,
      <img src={VmwareImage} alt="Vmware" key="11" />,
      <img src={AIJImage} alt="AIJ" key="12" />,
      <img src={PyaterochkaImage} alt="Пятёрочка" key="13" />,
      <img src={FirstBitImage} alt="Первый бит" key="14" />,
      <img src={YoomoneyImage} alt="Юмани" key="15" />,
      <img src={ROGImage} alt="ROG" key="16" />,
      <img src={DataForkImage} alt="Data Fork" key="17" />,
      <img src={OzonTechImage} alt="Ozon Tech" key="18" />,
      <img src={NilettoImage} alt="Niletto" key="19" />,
      <img src={RDSImage} alt="RDS" key="20" />,
      <img src={RosgonkiImage} alt="Rosgonki" key="21" />,
      <img src={SberDevicesImage} alt="Sber devices" key="22" />
    ],
    lgItemsCount: 6,
    mdItemsCount: 4,
    smItemsCount: 2
  }
};
